import { Component } from 'react';
import { withRouter } from 'react-router';
import { initSitePixel, trackPageView } from '../utils/metaPixel';

class PixelTracker extends Component {
    componentDidMount() {
        initSitePixel();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            trackPageView();
        }
    }

    render() {
        return null;
    }
}

export default withRouter(PixelTracker);
